(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

$(document).ready(function () {
    var $testimonialNav = $('#testimonial-nav'),
        $testimonialLink = $testimonialNav.find('li'),
        testimonialNumItems,
        testimonialPositionCount = 0,
        testimonialItem = $('#testimonials .widget-wysiwyg'),
        wrapperHeight = $('#testimonials .widget-wysiwyg:first-child').outerHeight();

    TestimonialCarousel();

    function TestimonialCarousel() {
        testimonialNumItems = testimonialItem.length;
        if (testimonialNumItems <= 1) {
            $testimonialNav.addClass('hidden');
        }
        var testimonialItemWidth = 100 / testimonialNumItems;
        var testimonialWrapContainer = testimonialNumItems * 100;
        $('.testimonials_wrapper_inner').css({ 'width': testimonialWrapContainer + '%', 'margin-left': '0', 'height': wrapperHeight });
        console.log(wrapperHeight);
        testimonialItem.css({ 'width': testimonialItemWidth + '%' });
    }

    $testimonialLink.click(testimonialCarouselMove);

    function testimonialCarouselMove() {
        var $this = $(this);
        if ($this.hasClass('disabled')) {
            return false;
        } else {
            $testimonialLink.removeClass('disabled');
            if ($this.hasClass('next')) {
                testimonialPositionCount++;
            } else {
                testimonialPositionCount--;
            }
            var itemCount = testimonialPositionCount + 1,
                wrapperHeight = $('#testimonials .widget-wysiwyg:nth-child(' + itemCount + ')').outerHeight();
            console.log(wrapperHeight);
            var testimonialCarouselOffset = 100 * testimonialPositionCount * -1;
            $('.testimonials_wrapper_inner').css({ 'margin-left': testimonialCarouselOffset + '%', 'height': wrapperHeight });
            if (testimonialPositionCount >= testimonialNumItems - 1) {
                $this.addClass('disabled');
            }
            if (testimonialPositionCount <= 0) {
                $this.addClass('disabled');
            }
        }
    }

    $('#menuToggle').click(function () {
        $('#main-nav > ul:not(.contact-menu)').slideToggle();
    });
});

$(function () {
    $(window).on('scroll', function () {
        var y_scroll_pos = window.pageYOffset;
        var scroll_pos_high = 100;
        var scroll_pos_low = 80;

        if (y_scroll_pos > scroll_pos_high) {
            $('#masthead').addClass('scrolled');
        }
        if (y_scroll_pos < scroll_pos_low) {
            $('#masthead').removeClass('scrolled');
        }
    });
});

},{}]},{},[1]);
